/**
 * form controls
 */
export function formControllInit() {
    let inputGroups = document.querySelectorAll('.input-group');
    inputGroups.forEach(group => {
        let input = group.querySelector('.form-control');
        input?.addEventListener("focus", () => {
            group.classList.add("input-group--focus");
        });
        input?.addEventListener("blur", () => {
            group.classList.remove("input-group--focus");
        });
    });
}
